import { ProductGame, ProductGameLong } from "@/@types/common";
import { CardProductGame } from "@/@types/data/collections";
import { LORCIcon, RPIcon, VCIcon } from "@/assets/svgs/CurrencyIcons";

export const CurrencyIconMap = {
  [CardProductGame.leagueoflegends]: RPIcon,
  [ProductGame.LeagueOfLegends]: RPIcon,
  [ProductGameLong[ProductGame.LeagueOfLegends]]: RPIcon,
  [CardProductGame.valorant]: VCIcon,
  [ProductGame.Valorant]: VCIcon,
  [ProductGameLong[ProductGame.Valorant]]: VCIcon,
  [CardProductGame.legendsofruneterra]: LORCIcon,
  [ProductGame.LegendsOfRuneterra]: LORCIcon,
  [ProductGameLong[ProductGame.LegendsOfRuneterra]]: LORCIcon,
};
